/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_TelefonnummerInputs */

const en__field_telefonnummer = /** @type {(inputs: _Field_TelefonnummerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone Number`)
};

const de__field_telefonnummer = /** @type {(inputs: _Field_TelefonnummerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefonnummer`)
};

/**
* | output |
* | --- |
* | "Phone Number" |
*
* @param {_Field_TelefonnummerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_telefonnummer = /** @type {((inputs?: _Field_TelefonnummerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_TelefonnummerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_telefonnummer(inputs)
	return de__field_telefonnummer(inputs)
});